import React, { useEffect } from "react";
import DotLoader from "../common3/Loaders/DotLoader";
import { Link } from "react-router-dom";
import {
  Wrapper,
  Content,
  HeadingWrapper,
  Heading,
  Cards,
  CardWrapper,
  Card,
  Img,
  TextWrapper,
  CardHeading,
  Text,
  ButtonSection,
  ButtonWrapper,
  Button,
} from "./styled";

const Categories = (props) => {
  const { runEffect = {}, extra = {}, effects, id } = props;
  const {
    categories = [],
    label,
    link = "category",
    includeMoreLink,
    moreLinkTo,
    moreLinkLabel,
  } = extra;

  useEffect(() => {
    runEffect({
      source: "Selfpoint/getCategories",
      effectId: id,
      context: { categories, asMap: true },
    });
  }, []);

  const cats = effects[id];

  return (
    <Wrapper className="sp-categories">
      <Content>
        {label && (
          <HeadingWrapper>
            <Heading>{label}</Heading>
          </HeadingWrapper>
        )}

        <Cards>
          {!cats && <DotLoader />}
          {cats &&
            categories &&
            categories.map(({ categoryId }, i) => {
              const d = cats[categoryId];

              if (!d) {
                return null;
              }

              return (
                <CardWrapper key={`category-card-${categoryId}-${i}`}>
                  <Link to={`/${link}?categoryId=${categoryId}`}>
                    <Card className="sp-categories-card" key={i}>
                      <Img className="sp-categories-card-img" img={d.img} />
                      <TextWrapper>
                        <CardHeading className="sp-categories-card-heading">
                          {d.name}
                        </CardHeading>
                        <Text className="sp-categories-card-text">
                          {d.description}
                        </Text>
                      </TextWrapper>
                    </Card>
                  </Link>
                </CardWrapper>
              );
            })}
        </Cards>
      </Content>
      {includeMoreLink && (
        <ButtonSection className="sp-categories-more-section">
          <ButtonWrapper>
            <Link className="sp-categories-more-link" to={moreLinkTo}>
              <Button className="sp-categories-more-btn">
                {moreLinkLabel}
              </Button>
            </Link>
          </ButtonWrapper>
        </ButtonSection>
      )}
    </Wrapper>
  );
};

export default Categories;
